export enum ESponsorType {
  Private = 'Private',
  Cvr = 'Cvr'
}

export function getSponsorTypes(): string[] {
  return Object.keys(ESponsorType);
}
